// @flow
export type ApiActionType = {
  FETCH: string,
  SUCCESS: string,
  FAILURE: string,
};

// https://github.com/redux-utilities/flux-standard-action
export type FluxStandardAction = {
  type: string,
  payload?: any,
  error?: string,
};

const createActionTypes = (module, apiName): ApiActionType => {
  return {
    FETCH: `${module}/${apiName}_FETCH`,
    SUCCESS: `${module}/${apiName}_FETCH_SUCCESS`,
    FAILURE: `${module}/${apiName}_FETCH_FAILURE`,
  };
};

export const ActionHelper = {
  createActionTypes,
};
